import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Tick from "../img/tick.svg";
import info_light from "../img/info_light.svg";
import ArrowBottom from "../img/ArrowBottom.svg";
import Add_round from "../img/Add_round.svg";
import Minus from "../img/Minus.svg";
import NavigateBackLogo from "../img/NavigateBackLogo.svg";
import api from "../../api/axiosInstance";
import { CartContext } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";

const PurchasedProductSingleView = () => {
  const navigate = useNavigate();
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  const location = useLocation();
  const { Id, itemType, item_id, project_code } = location.state || {};
  const [productDetails, setProductDetails] = useState(null);
  const [topUpPlans, setTopUpPlans] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { fetchCartCount } = useContext(CartContext);
  const topUpRef = useRef(null);

  const toggleTopUp = () => {
    setIsTopUpOpen((prev) => !prev);
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const token = localStorage.getItem("accessToken"); // optional if needed
        const response = await api.post(
          "/display/api/v1/read-my-products",
          {
            item_type: itemType,
            item_id: Id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // include if API is protected
            },
          }
        );

        if (response.data.status === "success") {
          setProductDetails(response.data.data);
        } else {
          console.error("Failed to fetch product details.");
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    const fetchTopUps = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await api.get(
          `/display/api/v1/list-top-ups-in-my-product/${item_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status === "success") {
          setTopUpPlans(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching top-up plans:", error);
      }
    };

    if (Id && itemType && item_id) {
      fetchProductDetails();
      fetchTopUps();
    }
  }, [Id, itemType, item_id]);

  const handleQuantityChange = (topupId, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [topupId]: Math.max(0, (prev[topupId] || 0) + delta),
    }));
  };

  const getTopUpTotal = () => {
    return topUpPlans.reduce((total, topup) => {
      const qty = quantities[topup.top_up_id] || 0;
      return total + topup.price * qty;
    }, 0);
  };

  const handleAddToCart = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    const selectedTopUps = topUpPlans
      .filter((topUp) => quantities[topUp.top_up_id] > 0)
      .map((topUp) => ({
        topup_id: topUp.top_up_id,
        quantity: quantities[topUp.top_up_id],
        price: topUp.price,
      }));

    if (selectedTopUps.length === 0) {
      alert("Please select at least one top-up to add to cart.");
      return;
    }

    try {
      const response = await api.post(
        "/display/api/v1/add-to-cart-from-my-products",
        { line_data: selectedTopUps },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.status === "success") {
        setShowSuccessModal(true);
        fetchCartCount();
        setIsTopUpOpen(false);
      } else {
        alert("Failed to add to cart: " + response.data.response_code);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Something went wrong while adding to cart.");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (topUpRef.current && !topUpRef.current.contains(event.target)) {
        setIsTopUpOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const today = new Date();
  const expiryDate = productDetails?.ending_date
    ? new Date(productDetails.ending_date)
    : null;

  let showRenewButton = false;
  if (expiryDate) {
    const diffInMs = expiryDate.getTime() - today.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    if (diffInDays <= 10) {
      showRenewButton = true;
    }
  }

  return (
    <div>
      {/* <div
        className="h-[62px] px-5 w-full bg-[#4C3A68] flex items-center  sticky top-0 z-50  "
        style={{ boxShadow: "0px 4px 5px 0px #8C62E280" }}
      >
        <img
          src={NavigateBackLogo}
          onClick={() => navigate(-1)}
          alt=""
          className="cursor-pointer hover:bg-[#5D4D76] rounded-full p-1"
        />
      </div> */}
      <Header></Header>
      <div class="px-4 sm:px-6 md:px-10 py-10">
        <div class="flex gap-3 sm:flex-row flex-col">
          <div className=" w-28 h-28 ">
            <img src={productDetails?.app_icon} alt="" />
          </div>
          <div className="flex flex-col w-[90%] justify-around">
            <span className="font-semibold text-2xl">
              {productDetails?.project_name}
            </span>
            <span className="text-lg">{productDetails?.company_name}</span>
            <span className="text-xs">{productDetails?.description}</span>
          </div>
        </div>

        <div
          className="border border-[#D9D9D9] rounded-lg py-5 my-5 px-5 flex flex-col gap-4"
          style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
        >
          <div className="flex w-full md:w-1/4 flex-col">
            <span className="font-semibold text-xl mb-2 md:mb-0">
              {productDetails?.item_name}
            </span>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 sm:gap-3 flex-grow">
            <div className="grid grid-rows-2 grid-flow-col gap-x-6 gap-y-3">
              {productDetails?.conditions?.map((condition, index) => (
                <div key={index} className="flex gap-1 items-center">
                  <img src={Tick} alt="tick" className="w-4 h-4" />
                  <span className="text-sm">{condition}</span>
                  <img src={info_light} alt="info" className="w-4 h-4" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {productDetails?.top_ups?.length > 0 && (
          <div
            className="border border-[#D9D9D9] rounded-lg py-5 my-5 px-5"
            style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
          >
            <div className="flex flex-col sm:flex-row justify-between w-full gap-3">
              <span className="text-xl font-semibold">Additional licenses</span>

              {/* <div className="relative w-full sm:w-64">
                <div
                  className={`flex flex-col cursor-pointer rounded px-3 py-2 transition-all duration-300 ${
                    isTopUpOpen
                      ? "bg-[#FFFFFF] border"
                      : "bg-[#CEC7FF4D] border border-transparent"
                  }`}
                  onClick={toggleTopUp}
                >
                  <div className="flex justify-between items-center">
                    <span className="text-[#9367D7] text-sm font-semibold">
                      Add more
                    </span>
                    <img
                      src={ArrowBottom}
                      alt=""
                      className={`transform transition-transform duration-300 ${
                        isTopUpOpen ? "rotate-180" : ""
                      }`}
                    />
                  </div>
                </div>

                {isTopUpOpen && (
                  <div
                    ref={topUpRef}
                    className="absolute top-full left-0 z-10 mt-2 w-full bg-white rounded-lg shadow-lg border px-3 py-2"
                  >
                    {topUpPlans.length === 0 ? (
                      <div className="text-sm text-gray-500">
                        No top-up plans available.
                      </div>
                    ) : (
                      topUpPlans.map((topUp) => (
                        <div
                          key={topUp.top_up_id}
                          className="w-full bg-white rounded-lg shadow border border-[#9367D7] px-3 py-2 mb-2"
                        >
                          <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                            <div className="flex flex-col gap-1">
                              <span className="text-xs">{topUp.name}</span>
                              <span className="text-[#ACA7A7] text-xs">
                                ₹{topUp.price}/qty
                              </span>
                            </div>

                            <div className="flex gap-1 items-center">
                              <img
                                src={Minus}
                                alt="Decrease"
                                className="cursor-pointer w-[20px]"
                                onClick={() =>
                                  handleQuantityChange(topUp.top_up_id, -1)
                                }
                              />
                              <input
                                type="number"
                                value={quantities[topUp.top_up_id] || 0}
                                readOnly
                                className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                              />
                              <img
                                src={Add_round}
                                alt="Increase"
                                className="cursor-pointer w-[20px]"
                                onClick={() =>
                                  handleQuantityChange(topUp.top_up_id, 1)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))
                    )}

                    <div className="flex w-full justify-between mt-4">
                      <span className="font-semibold text-xs">
                        Top up Total pay
                      </span>
                      <span className="text-sm">₹ {getTopUpTotal()}</span>
                    </div>
                    <div className="flex w-full justify-end mt-2">
                      <button
                        className="font-semibold text-sm text-white px-3 py-2 rounded-lg"
                        style={{
                          background:
                            "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                        }}
                        onClick={handleAddToCart}
                      >
                        Add to cart
                      </button>
                    </div>
                  </div>
                )}
              </div> */}
            </div>
            <div className="mt-3"></div>
            {productDetails?.top_ups?.map((top_up, index) => (
              <div key={index} className="flex gap-12">
                <div className="flex gap-4">
                  <span className="text-sm font-medium ">
                    {top_up.top_up_name}
                  </span>
                  <span className="text-sm  ">{top_up.price}/qty</span>
                </div>

                <span className="text-sm ">
                  Count : {""}
                  {top_up.count}
                </span>
              </div>
            ))}

            {/* Top-up Summary Below */}
            {/* <div className="flex flex-col sm:flex-row gap-4 mt-4 w-full">
            <div className="flex flex-col gap-2 w-full sm:w-1/2">
              {[1, 2, 3].map((_, i) => (
                <div
                  key={i}
                  className="flex flex-col sm:flex-row gap-3 text-sm"
                >
                  <span>Feature name</span>
                  <span>₹120/qty</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-2 w-full sm:w-1/2">
              {[1, 2, 3].map((_, i) => (
                <div
                  key={i}
                  className="flex flex-col sm:flex-row gap-3 text-sm"
                >
                  <span>Count : 12</span>
                </div>
              ))}
            </div>
          </div> */}
          </div>
        )}

        <div
          className="border border-[#D9D9D9] rounded-lg py-5 my-5 px-5"
          style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
        >
          <div className="overflow-x-auto">
            <div className="min-w-[600px] space-y-2">
              {/* Table Header */}
              <div className="grid grid-cols-5 bg-[#CEC7FF4D] text-sm h-10 items-center px-4 rounded font-semibold">
                <span>No.</span>
                <span>Limit</span>
                <span>Total</span>
                <span>Used</span>
                <span>Balance</span>
              </div>

              {/* Table Row 1 */}
              {productDetails?.limits_details?.map((limit, index) => (
                <div
                  key={index}
                  className="grid grid-cols-5 text-sm h-10 items-center px-4 rounded"
                >
                  <span>{index + 1}</span>
                  <span>{limit.limit_name}</span>
                  <span>{limit.total}</span>
                  <span>{limit.used}</span>
                  <span>{limit.balance}</span>
                </div>
              ))}

              {/* Table Row 2 */}
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col sm:flex-row justify-between px-5 ">
          {productDetails?.ending_date && (
            <span className="text-lg">
              Expiry Date :{" "}
              {new Date(productDetails.ending_date).toLocaleDateString()}
            </span>
          )}

          <div className="flex gap-4">
            {productDetails?.item_type === "license" && (
              <span
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                className="font-semibold text-white h-8 flex justify-center text-sm rounded cursor-pointer w-full items-center sm:w-28"
                onClick={() =>
                  navigate("/upgradedPlan", {
                    state: {
                      org_mapper_id: Id,
                      item_type: itemType,
                      item_id: item_id,
                      project_code: project_code,
                    },
                  })
                }
              >
                Upgrade Plan
              </span>
            )}

            <span
              style={{
                background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
              }}
              className="font-semibold text-white h-8 flex justify-center cursor-pointer text-sm rounded w-full items-center sm:w-28"
              onClick={() =>
                navigate("/RenewLicensePage", {
                  state: {
                    org_mapper_id: productDetails.id,
                    item_type: productDetails.item_type,
                    item_id: item_id,
                    project_code: project_code,
                  },
                })
              }
            >
              Renew
            </span>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
          <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full">
            <h2 className="text-xl font-bold text-green-600 mb-4 text-center">
              Success!
            </h2>
            <p className="text-center text-gray-700 mb-4">
              Top-ups added to cart successfully!
            </p>
            <div className="flex justify-center">
              <button
                className="bg-gradient-to-r from-purple-600 to-indigo-500 text-white px-4 py-2 rounded-md"
                onClick={() => setShowSuccessModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchasedProductSingleView;
